import { IFutureWithOrder } from '../../repositories/infrastructure-caching/entities/get_infrastructure/FutureWithOrder';
import { IDistrictFuture } from '../../types/infrastructure';

/** Если бэк не прислал год окончания, считаем, что стройка идёт не дольше четырёх лет. */
const MAX_CONSTRUCTION_PERIOD = 4;
/** Таймлайн будущего района: текущий год и четыре следующих. */
export const FUTURE_YEARS_COUNT = 5;

export function getFutureYears(currentYear: number): number[] {
  return Array.from({ length: FUTURE_YEARS_COUNT }, (_, index) => currentYear + index);
}

function isInFutureWindow(
  { constructionYearFrom, constructionYearTo }: { constructionYearFrom: number; constructionYearTo?: number | null },
  currentYear: number,
): boolean {
  const yearTo = constructionYearTo ?? constructionYearFrom + MAX_CONSTRUCTION_PERIOD;
  const lastTimelineYear = currentYear + FUTURE_YEARS_COUNT - 1;

  return constructionYearFrom <= lastTimelineYear && yearTo >= currentYear;
}

/**
 * Переводит блок «Будущее района» из ответа infrastructure-caching в данные карты.
 * Возвращает null, когда в пятилетнем окне таймлайна нет ни объектов, ни дорог —
 * по этому признаку скрывается сам переключатель режима.
 */
export function mapFutureData(future: IFutureWithOrder | null | undefined, currentYear: number): IDistrictFuture | null {
  if (!future) {
    return null;
  }

  const pois = (future.infrastructure ?? [])
    .filter(item => isInFutureWindow(item, currentYear))
    .map(item => ({
      id: item.id,
      type: item.type,
      title: item.title,
      coordinates: { lat: item.coordinates.lat, lng: item.coordinates.lng },
      constructionYearFrom: item.constructionYearFrom,
      constructionDateText: item.constructionDateText,
    }));

  const roads = (future.roads ?? [])
    .filter(road => isInFutureWindow(road, currentYear))
    .map(road => ({
      id: road.id,
      title: road.title,
      coordinates: { lat: road.coordinates.lat, lng: road.coordinates.lng },
      line: road.lineString.map(({ lat, lng }) => ({ lat, lng })),
      constructionYearFrom: road.constructionYearFrom,
      constructionDateText: road.constructionDateText,
    }));

  if (!pois.length && !roads.length) {
    return null;
  }

  return { pois, roads };
}
